import React, { Component } from "react";
import classnames from "classnames";
import styles from "./AssociateDashboardsPage.local.scss";
import SidePageHeader from "../Common/SidePageHeader/SidePageHeader";
import { ModalConfirm } from "tamtam-components";
import _ from "i18n";
import { connect } from "react-redux";
import AssociationLegalForme from "../Common/AssociationLegalForme/AssociationLegalForme";
import { goBack, push } from "react-router-redux";

class AssociateDashbboardsPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      disabled: true,
      isOpenModal: false,
      isPage: true
    };
  }

  handleDisabled = disabled => {
    this.setState({ disabled: disabled });
  };
  handleClosePage = () => {
    const { dispatch, backOffice } = this.props;
    let { disabled } = this.state;
    if (!disabled) {
      this.setState({ isOpenModal: true });
    } else {
      if (backOffice) {
        dispatch(goBack());
      } else {
        dispatch(push("/folders"));
      }
    }
  };
  render() {
    const { dispatch } = this.props;
    let { isPage, isOpenModal, disabled } = this.state;

    return (
      <div className={classnames(styles.associate_dashboards, "page-content")}>
        <SidePageHeader
          subHeader="manageAssociations"
          withReturnButton={true}
          handleReturnTo={this.handleClosePage}
        />

        <div className={styles.associations_block}>
          <div className={styles.title_block}>
            <h2 className={styles.title}>{_("associationLegalForm")}</h2>
          </div>
          <div className={styles.tabs_block} />
          <AssociationLegalForme
            handleClosePage={this.handleClosePage}
            handleDisabled={this.handleDisabled}
            isPage={isPage}
            disabled={disabled}
          />
        </div>
        <ModalConfirm
          type={"return"}
          isOpen={isOpenModal}
          onCancel={() => this.setState({ isOpenModal: false })}
          onConfirm={() => {
            dispatch(push("/folders"));
          }}
          inProcess={false}
          actionFailed={false}
          title={_("exitConfirm")}
          text={_("cancelConfirmContent")}
          labelNo={_("cancel")}
          labelYes={_("exit")}
          labelError={"Error"}
        />
      </div>
    );
  }
}
// Connected Component
const mapStateToProps = state => ({
  fetching: state.organizations.association.fetching,
  backOffice: state.params.backOffice
});

export default connect(mapStateToProps)(AssociateDashbboardsPage);



// WEBPACK FOOTER //
// ./src/components/AssociateDashboards/AssociateDashboardsPage.js